import React, { useEffect, useState } from 'react'
import { Redirect, Route } from 'react-router-dom';
import {useAuth} from '../auth/AuthContext';
import routes from '../views/routes';



export default function PrivateRoute({ component: Component, ...rest }) {
    const { currentUser, tokenExp, setPath } = useAuth();
    return (
        <Route {...rest}
        render = {props => {
            const currentPath = props.location.pathname;
            const isSignup = currentPath.indexOf(routes.SIGNUP_PAGE) != -1;
            const isAdminPage = currentPath.toLowerCase().indexOf('admin') != -1;
            setPath(currentPath);
            if(isSignup) {
                return (!currentUser ? <Component {...props} /> : <Redirect to= {routes.JOBS} />)
            } else if (isAdminPage) {
                return (currentUser && currentUser.UserRole.toLowerCase() == 'admin' ? <Component {...props} /> : <Redirect to= {routes.JOBS} />)
            }

            return (currentUser && tokenExp  > new Date())? <Component {...props} /> : <Redirect to= {routes.LOGIN_PAGE} />
        }} 
        >

        </Route>
    )
}